import { gettext } from "../utils/legacy";
import React from "react";

export type SaveButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  disabled?: boolean;
  className?: string;
  /**
   *  Shows a loader in the button.
   */
};

/**
 * SaveButton renders to a `<Button type="submit" />` and can therefore be used in forms as a submit button.
 */

const SaveButton = ({ children, className, ...props }: SaveButtonProps) => (
  <button type="submit" className={`btn btn-primary ${className}`} {...props}>
    {children || gettext("Save")}
  </button>
);
export default SaveButton;
